import React from "react";
import "./commonHeader.scss";

const CommonHeader = ({ title, subtitle, bgText, center }) => {
  return (
    <div
      className={center ? "commonHeader commonHeader--center" : "commonHeader"}
    >
      <span className="commonHeader__title">{title}</span>
      <span className="commonHeader__subtitle">{subtitle}</span>

      <div
        className={
          center
            ? "commonHeader__layer commonHeader--center"
            : "commonHeader__layer"
        }
      >
        <span className="commonHeader__bgText">{bgText}</span>
      </div>
    </div>
  );
};

export default CommonHeader;
